import { render, staticRenderFns } from "./dialogVersion.vue?vue&type=template&id=491556ab&scoped=true"
import script from "./dialogVersion.vue?vue&type=script&lang=js"
export * from "./dialogVersion.vue?vue&type=script&lang=js"
import style0 from "./dialogVersion.vue?vue&type=style&index=0&id=491556ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491556ab",
  null
  
)

export default component.exports